import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const duplicateElement = (elementId, updateStrategy) => {
  const element = getLiveElement(elementId);
  instance.driver.duplicateElement(element, updateStrategy);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default duplicateElement;
